import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import MakeUser from "../manage/users/MakeUser";
import Favorites from "./Favorites";
import MainPageSkeleton from "../../components/loaders/MainPageSkeleton";
import {Typography} from "@mui/material";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import Container from '@mui/material/Container';
import Title from "../../components/elements/Title";
import {connect, setStore} from "trim-redux";
import {ChevronRight, Heart} from "lucide-react";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import NothingFound from "../../components/elements/NothingFound";

function FavoritesPage({edit,isAuth}){
    const { t } = useTranslation();
    const [totalRes, setTotalRes] = useState(null);
    useEffect(() => {
        setStore(({
            global_menu:"home"
        }))
    },[]);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('favorites')}>
            <div className="page-color-layout">
                <>
                    <section className="category-page-top">
                        <Container maxWidth="xl" >
                            <Grid container spacing={2}>
                                <Grid item size={12}>
                                    <div className="infos">
                                        <div className="informations">
                                            <Title component="h1" align="left" color="text" className="page-title">{t('favorites')}</Title>
                                            <BreadCrumbs
                                                front
                                                singleLevel
                                                firstText={t('favorites')}
                                            />
                                        </div>
                                        {
                                            (!!totalRes && totalRes > 0) &&
                                            <Typography className="results">{totalRes} {t(totalRes === 1 ?  'resultFound' : 'resultsFound')}</Typography>
                                        }

                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>
                    <Container maxWidth="xl" >
                        {
                            !!isAuth ?
                                <Favorites setTotal={setTotalRes}/>
                                :
                                <Grid continer spacing={2}>
                                    <Grid item size={12}>
                                        <NothingFound
                                            type="page"
                                            title={t('loginToViewWishlists')}
                                            title_color="text"
                                            paragraph={t('loginToViewWishlistsDesc')}
                                            icon={<Heart/>}
                                        >
                                            <Button
                                                variant="outlined"
                                                endIcon={<ChevronRight/>}
                                                component={Link}
                                                to={`/login`}
                                            >
                                                {t('login')}
                                            </Button>
                                        </NothingFound>
                                    </Grid>
                                </Grid>
                        }

                    </Container>
                </>
            </div>
        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(FavoritesPage));
